interface DoneStepProps {
  finish: () => void
  loading: boolean
  t: (key: string) => string
}

export default function DoneStep({ finish, loading, t }: DoneStepProps) {
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 'var(--text-display-3xl)', marginBottom: 20 }}>🎉</div>
      <h2 style={{ fontSize: 'var(--text-4xl)', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 12 }}>
        {t('youreAllSet')}
      </h2>
      <p style={{ fontSize: 'var(--text-md)', color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: 36 }}>
        {t('workspaceReady')}
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 40, textAlign: 'left' }}>
        {[
          ['📦', t('onboardingNextAddItems'), t('onboardingNextAddItemsDesc')],
          ['👥', t('onboardingNextInviteTeam'), t('onboardingNextInviteTeamDesc')],
          ['🎭', t('onboardingNextCreateProduction'), t('onboardingNextCreateProductionDesc')],
        ].map(([icon, title, desc]) => (
          <div key={title} style={{
            display: 'flex', gap: 14, alignItems: 'flex-start',
            background: 'var(--bg-elevated)', borderRadius: 10, padding: '14px 16px',
          }}>
            <span style={{ fontSize: 'var(--text-2xl)', marginTop: 1 }}>{icon}</span>
            <div>
              <p style={{ fontSize: 'var(--text-base)', fontWeight: 600, color: 'var(--text-primary)', margin: '0 0 3px' }}>{title}</p>
              <p style={{ fontSize: 'var(--text-caption)', color: 'var(--text-muted)', margin: 0 }}>{desc}</p>
            </div>
          </div>
        ))}
      </div>
      <button
        onClick={finish}
        disabled={loading}
        style={{
          width: '100%', padding: '14px', borderRadius: 10,
          background: 'var(--accent)', color: 'var(--text-inverse)',
          border: 'none', fontSize: 'var(--text-md)', fontWeight: 600,
          cursor: loading ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? t('loading') : t('goToDashboard')}
      </button>
    </div>
  )
}
